import { useEffect, useState } from "react";
import TodayLeaderboard from "../components/TodayLeaderboard";
import { apiUrl } from "../utils/api";
import "../style/Quiz.css";

const TODAY_SCORES_API_URL = process.env.REACT_APP_TODAY_SCORES_API_URL
    || apiUrl("today_scores.php");

export default function TodayScoresPage({ text }) {
    const [entries, setEntries] = useState([]);
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [reload, setReload] = useState(0);

    useEffect(() => {
        const controller = new AbortController();
        setIsLoading(true);
        setError("");
        fetch(TODAY_SCORES_API_URL, { signal: controller.signal })
            .then(async (response) => {
                const result = await response.json();
                if (!response.ok) {
                    throw new Error(result.error || `Today scores API returned HTTP ${response.status}`);
                }
                if (!Array.isArray(result.entries)) {
                    throw new Error("Today scores API returned invalid entries");
                }
                setEntries(result.entries);
            })
            .catch((requestError) => {
                if (requestError.name !== "AbortError") {
                    console.error("Failed to load today's quiz scores:", requestError);
                    setError(text.todayScoresLoadError);
                }
            })
            .finally(() => {
                if (!controller.signal.aborted) {
                    setIsLoading(false);
                }
            });

        return () => controller.abort();
    }, [reload, text.todayScoresLoadError]);

    return (
        <main className="today-scores-page">
            <header className="catalog-header">
                <span className="quiz-label">{text.todayScoresPageLabel}</span>
                <h1>{text.todayLeaderboardTitle}</h1>
            </header>
            {isLoading ? (
                <p className="quiz-empty-state" role="status">
                    {text.todayScoresLoading}
                </p>
            ) : error ? (
                <div className="quiz-empty-state" role="alert">
                    <p>{error}</p>
                    <button
                        className="quiz-btn"
                        type="button"
                        onClick={() => setReload((version) => version + 1)}
                    >
                        {text.retry}
                    </button>
                </div>
            ) : (
                <TodayLeaderboard entries={entries} text={text} />
            )}
        </main>
    );
}
